import { AnswerType, FontView } from '@packages/types'
import React from 'react'
import { components, GroupBase, OptionProps } from 'react-select'

import CheckboxIcon from 'themes/common/components/answers/CheckboxIcon'
import FontPreview from 'themes/common/components/FontPreview'
import { Option } from 'themes/common/components/questions/dropdown/useDropdownQuestionOptions'
import SanitizedHtml from 'themes/common/components/SanitizedHtml'
import isNullOrEmpty from 'utils/isNullOrEmpty'

export type DropdownQuestionOptionProps = OptionProps<Option, boolean, GroupBase<Option>>

const DropdownQuestionOption = ({ children, ...props }: DropdownQuestionOptionProps) => {
  const { views = [], value } = props.data

  const fontView = views[0]?.type === AnswerType.Font ? (views[0] as FontView) : undefined
  const showFontPreview = !!fontView && !isNullOrEmpty(fontView.assets)

  if (props.isMulti) {
    return (
      <components.Option {...props}>
        <div className="dropdown-custom-option">
          <div className="option-label">
            {showFontPreview ? <FontPreview fontView={fontView} text={value} /> : <span>{children}</span>}

            <span className="dropdown-option__check-container">
              <CheckboxIcon
                width={16}
                gap={4.82}
                selected={props.isSelected}
                fillOpacity={1}
                iconColor={props.selectProps.customProps.checkboxStyle?.iconColor}
                borderColor={props.selectProps.customProps.checkboxStyle?.borderColor}
                backgroundColor={props.selectProps.customProps.checkboxStyle?.backgroundColor}
              />
            </span>
          </div>

          {props?.data?.showDescription && (
            <SanitizedHtml style={{ opacity: '54%' }} dirtyHtml={props.data.description} />
          )}
        </div>
      </components.Option>
    )
  }

  return (
    <components.Option {...props}>
      <div className="dropdown-custom-option">
        <div className="option-label">
          {showFontPreview ? <FontPreview fontView={fontView} text={value} /> : <span>{children}</span>}
        </div>

        {props?.data?.showDescription && (
          <SanitizedHtml style={{ opacity: '54%' }} dirtyHtml={props.data.description} />
        )}
      </div>
    </components.Option>
  )
}

export default DropdownQuestionOption
